import madridImage from '../assets/images/covers/Madrid.png';
import barcelonaImage from '../assets/images/covers/Barcelona.png';
import valenciaImage from '../assets/images/covers/Valencia.png';
import sevillaImage from '../assets/images/covers/Sevilla.png';
import aCorunaImage from '../assets/images/covers/ACoruna.png';
import leonImage from '../assets/images/covers/Leon.png';
import sanSebastianImage from '../assets/images/covers/SanSebastian.png';
import santanderImage from '../assets/images/covers/Santander.png';
import ibizaImage from '../assets/images/covers/Ibiza.png';
import marbellaImage from '../assets/images/covers/Marbella.png';
import alicanteImage from '../assets/images/covers/Alicante.png';
import palmaDeMallorcaImage from '../assets/images/covers/PalmaDeMallorca.png';
import oviedoImage from '../assets/images/covers/Oviedo.png';
import valladolidImage from '../assets/images/covers/Valladolid.png';
import tenerifeImage from '../assets/images/covers/Tenerife.png';
import granCanariaImage from '../assets/images/covers/GranCanaria.png';
import malagaImage from '../assets/images/covers/Malaga.png';
import zaragozaImage from '../assets/images/covers/Zaragoza.png';
import vitoriaImage from '../assets/images/covers/Vitoria.png';
import bilbaoImage from '../assets/images/covers/Bilbao.png';
import pamplonaImage from '../assets/images/covers/Pamplona.png';
import vigoImage from '../assets/images/covers/Vigo.png';
import lanzaroteImage from '../assets/images/covers/Lanzarote.png';
import logronoImage from '../assets/images/covers/Logrono.png';
import murciaImage from '../assets/images/covers/Murcia.png';
import burgosImage from '../assets/images/covers/Burgos.png';


export const cityContent = {
  madrid: {
    path: '/pop-up-stores-madrid',
    routeName: 'LandingPageMadrid',
    bounds: '40.82368302,-3.49513437,40.11487892,-4.06594522',
    origin: '40.4168,-3.7038',
    address: 'Madrid, Spain',
    image: madridImage,
    searchParams: {
      address: 'Madrid,%20Spain',
      bounds: '40.82368302%2C-3.49513437%2C40.11487892%2C-4.06594522'
    }
  },
  barcelona: {
    path: '/pop-up-stores-barcelona',
    routeName: 'LandingPageBarcelona',
    bounds: '41.4689,2.2286,41.3200,2.0522',
    origin: '41.3851,2.1734',
    address: 'Barcelona, Spain',
    image: barcelonaImage,
    searchParams: {
      address: 'Barcelona%2C%20provincia%20de%20Barcelona%2C%20España',
      bounds: '41.468253%2C2.241492%2C41.298695%2C2.052453'
    }
  },
  valencia: {
    path: '/pop-up-stores-valencia',
    routeName: 'LandingPageValencia',
    bounds: '39.5132,-0.2789,39.3281,-0.4656',
    origin: '39.4699,-0.3763',
    address: 'Valencia, Spain',
    image: valenciaImage,
    searchParams: {
      address: 'Valencia%2C%20Spain',
      bounds: '39.5132%2C-0.2789%2C39.3281%2C-0.4656'
    }
  },
  sevilla: {
    path: '/pop-up-stores-sevilla',
    routeName: 'LandingPageSevilla',
    bounds: '37.4341,-5.9256,37.3317,-6.0042',
    origin: '37.3886,-5.9953',
    address: 'Sevilla, Spain',
    image: sevillaImage,
    searchParams: {
      address: 'Sevilla%2C%20Spain',
      bounds: '37.4341%2C-5.9256%2C37.3317%2C-6.0042'
    }
  },
  aCoruna: {
    path: '/pop-up-stores-a-coruna',
    routeName: 'LandingPageACoruna',
    bounds: '43.4094,-8.360962,43.3012,-8.479335',
    origin: '43.3623,-8.4115',
    address: 'A Coruña, Spain',
    image: aCorunaImage,
    searchParams: {
      address: 'A%20Coruña%2C%20provincia%20de%20La%20Coruña%2C%20España',
      bounds: '43.409496%2C-8.360962%2C43.30122%2C-8.479335'
    }
  },
  leon: {
    path: '/pop-up-stores-leon',
    routeName: 'LandingPageLeon',
    bounds: '42.640323, -5.533771, 42.548027, -5.630763',
    origin: '42.5987,-5.5671',
    address: 'León, Spain',
    image: leonImage,
    searchParams: {
      address: 'León%2C%20provincia%20de%20León%2C%20España',
      bounds: '42.640323%2C-5.533771%2C42.548027%2C-5.630763'
    }
  },
  sanSebastian: {
    path: '/pop-up-stores-san-sebastian',
    routeName: 'LandingPageSanSebastian',
    bounds: '43.37797613,-1.92994092,43.25263128,-2.03442492',
    origin: '43.3213,-1.9850',
    address: 'San Sebastián, Spain',
    image: sanSebastianImage,
    searchParams: {
      address: 'Antiguo%2C%20Donostia%2C%20Guipúzcoa%2C%20España',
      bounds: '43.37797613%2C-1.92994092%2C43.25263128%2C-2.03442492'
    }
  },
  santander: {
    path: '/pop-up-stores-santander',
    routeName: 'LandingPageSantander',
    bounds: '43.514466,-3.742616,43.433615,-3.890429',
    origin: '43.4623,-3.8099',
    address: 'Santander, Spain',
    image: santanderImage,
    searchParams: {
      address: 'Santander%2C%20Cantabria%2C%20España',
      bounds: '43.514466%2C-3.742616%2C43.433615%2C-3.890429'
    }
  },
  ibiza: {
    path: '/pop-up-stores-ibiza',
    routeName: 'LandingPageIbiza',
    bounds: '38.97940189,1.47856074,38.70539472,1.30043826',
    origin: '38.9089,1.4321',
    address: 'Ibiza, Spain',
    image: ibizaImage, // Corrected case if file exists, otherwise remains potentially broken
    searchParams: {
      address: 'Ibiza%2C%20Madrid%2C%20Madrid%2C%20España',
      bounds: '38.97940189%2C1.47856074%2C38.70539472%2C1.30043826'
    }
  },
  marbella: {
    path: '/pop-up-stores-marbella',
    routeName: 'LandingPageMarbella',
    bounds: '36.55482,-4.726904,36.439144,-5.014868',
    origin: '36.5101,-4.8825',
    address: 'Marbella, Spain',
    image: marbellaImage, // Corrected case if file exists, otherwise remains potentially broken
    searchParams: {
      address: 'Marbella%2C%20provincia%20de%20Málaga%2C%20España',
      bounds: '36.55482%2C-4.726904%2C36.439144%2C-5.014868'
    }
  },
  alicante: {
    path: '/pop-up-stores-alicante',
    routeName: 'LandingPageAlicante',
    bounds: '38.39093949,-0.45510344,38.29161301,-0.52829717',
    origin: '38.3452,-0.4810',
    address: 'Alicante, Spain',
    image: alicanteImage, // Corrected case if file exists, otherwise remains potentially broken
    searchParams: {
      address: 'Alicante%2C%20provincia%20de%20Alicante%2C%20España',
      bounds: '38.39093949%2C-0.45510344%2C38.29161301%2C-0.52829717'
    }
  },
  palmaDeMallorca: {
    path: '/pop-up-stores-palma-de-mallorca',
    routeName: 'LandingPagePalmaDeMallorca',
    bounds: '39.59171125,2.66627379,39.55059282,2.63544312',
    origin: '39.5696,2.6502',
    address: 'Palma de Mallorca, Spain',
    image: palmaDeMallorcaImage, // Corrected filename case
    searchParams: {
      address: 'Mallorca%2C%20Islas%20Baleares%2C%20España',
      bounds: '39.59171125%2C2.66627379%2C39.55059282%2C2.63544312'
    }
  },
  oviedo: {
    path: '/pop-up-stores-oviedo',
    routeName: 'LandingPageOviedo',
    bounds: '43.3788649,-5.82966185,43.33484509,-5.86465365',
    origin: '43.3619,-5.8494',
    address: 'Oviedo, Spain',
    image: oviedoImage,
    searchParams: {
      address: 'Oviedo%2C%20Asturias%2C%20España',
      bounds: '43.3788649%2C-5.82966185%2C43.33484509%2C-5.86465365'
    }
  },
  valladolid: {
    path: '/pop-up-stores-valladolid',
    routeName: 'LandingPageValladolid',
    bounds: '41.73827149,-4.67010102,41.54606259,-4.81875652',
    origin: '41.6523,-4.7245',
    address: 'Valladolid, Spain',
    image: valladolidImage, // Corrected filename case
    searchParams: {
      address: 'Valladolid%2C%20provincia%20de%20Valladolid%2C%20España',
      bounds: '41.73827149%2C-4.67010102%2C41.54606259%2C-4.81875652'
    }
  },
  tenerife: {
    path: '/pop-up-stores-tenerife',
    routeName: 'LandingPageTenerife',
    bounds: '228.69999578,-16.20253937,27.60264768,-16.92188743',
    origin: '28.4636,-16.2518',
    address: 'Tenerife, Spain',
    image: tenerifeImage, // Corrected filename case
    searchParams: {
      address: 'Tenerife%2C%20Spain',
      bounds: '28.69999578%2C-16.20253937%2C27.60264768%2C-16.92188743'
    }
  },
  granCanaria: {
    path: '/pop-up-stores-gran-canaria',
    routeName: 'LandingPageGranCanaria',
    bounds: '28.181587,-15.358514,27.734504,-15.834647',
    origin: '28.1235,-15.4363',
    address: 'Gran Canaria, Spain',
    image: granCanariaImage, // Corrected filename case
    searchParams: {
      address: 'Gran%20Canaria%2C%20Las%20Palmas%2C%20España',
      bounds: '28.181587%2C-15.358514%2C27.734504%2C-15.834647'
    }
  },
  malaga: {
    path: '/pop-up-stores-malaga',
    routeName: 'LandingPageMalaga',
    bounds: '36.77837855,-4.38409278,36.66486688,-4.46594253',
    origin: '36.7213,-4.4214',
    address: 'Málaga, Spain',
    image: malagaImage,
    searchParams: {
      address: 'Málaga%2C%20provincia%20de%20Málaga%2C%20España',
      bounds: '36.77837855%2C-4.38409278%2C36.66486688%2C-4.46594253'
    }
  },
  zaragoza: {
    path: '/pop-up-stores-zaragoza',
    routeName: 'LandingPageZaragoza',
    bounds: '41.71790709,-0.83368761,41.55847962,-0.95698211',
    origin: '41.6488,-0.8891',
    address: 'Zaragoza, Spain',
    image: zaragozaImage, // Corrected filename case
    searchParams: {
      address: 'Zaragoza%2C%20provincia%20de%20Zaragoza%2C%20España',
      bounds: '41.71790709%2C-0.83368761%2C41.55847962%2C-0.95698211'
    }
  },
  vitoria: {
    path: '/pop-up-stores-vitoria',
    routeName: 'LandingPageVitoria',
    bounds: '42.89449309,-2.63703634,42.79136439,-2.7183292',
    origin: '42.8467,-2.6727',
    address: 'Vitoria-Gasteiz, Spain',
    image: vitoriaImage, // Corrected filename case
    searchParams: {
      address: 'Vitoria-Gasteiz%2C%20Álava%2C%20España',
      bounds: '42.89449309%2C-2.63703634%2C42.79136439%2C-2.7183292'
    }
  },
  bilbao: {
    path: '/pop-up-stores-bilbao',
    routeName: 'LandingPageBilbao',
    bounds: '43.28911876,-2.90793043,43.22052807,-2.96236243',
    origin: '43.2630,-2.9350',
    address: 'Bilbao, Spain',
    image: bilbaoImage,
    searchParams: {
      address: 'Bilbao%2C%20Vizcaya%2C%20España',
      bounds: '43.28911876%2C-2.90793043%2C43.22052807%2C-2.96236243'
    }
  },
  pamplona: {
    path: '/pop-up-stores-pamplona',
    routeName: 'LandingPagePamplona',
    bounds: '42.842433,-1.604513,42.788748,-1.695374',
    origin: '42.8125,-1.6458',
    address: 'Pamplona, Spain',
    image: pamplonaImage, // Corrected filename case
    searchParams: {
      address: 'Pamplona%2C%20Navarra%2C%20España',
      bounds: '42.842433%2C-1.604513%2C42.788748%2C-1.695374'
    }
  },
  vigo: {
    path: '/pop-up-stores-vigo',
    routeName: 'LandingPageVigo',
    bounds: '42.26174385,-8.69461518,42.18819184,-8.75202285',
    origin: '42.2406,-8.7207',
    address: 'Vigo, Spain',
    image: vigoImage, // Corrected filename case
    searchParams: {
      address: 'Vigo%2C%20provincia%20de%20Pontevedra%2C%20España',
      bounds: '42.26174385%2C-8.69461518%2C42.18819184%2C-8.75202285'
    }
  },
  lanzarote: {
    path: '/pop-up-stores-lanzarote',
    routeName: 'LandingPageLanzarote',
    bounds: '29.240977,-13.419154,28.838402,-13.881877',
    origin: '28.9630,-13.5477',
    address: 'Lanzarote, Spain',
    image: lanzaroteImage, // Corrected case if file exists, otherwise remains potentially broken
    searchParams: {
      address: 'Lanzarote%2C%20Las%20Palmas%2C%20España',
      bounds: '29.240977%2C-13.419154%2C28.838402%2C-13.881877'
    }
  },
  logrono: {
    path: '/pop-up-stores-logroño',
    routeName: 'LandingPageLogrono',
    bounds: '42.49178068,-2.41902833,42.42739891,-2.46946646',
    origin: '42.4667,-2.4497',
    address: 'Logroño, Spain',
    image: logronoImage, // Corrected filename case
    searchParams: {
      address: 'Logroño%2C%20La%20Rioja%2C%20España',
      bounds: '42.49178068%2C-2.41902833%2C42.42739891%2C-2.46946646'
    }
  },
  murcia: {
    path: '/pop-up-stores-murcia',
    routeName: 'LandingPageMurcia',
    bounds: '38.12826405,-1.01228876,37.76400732,-1.27926076',
    origin: '37.9922,-1.1307',
    address: 'Murcia, Spain',
    image: murciaImage, // Corrected filename case
    searchParams: {
      address: 'Murcia%2C%20Región%20de%20Murcia%2C%20España',
      bounds: '38.12826405%2C-1.01228876%2C37.76400732%2C-1.27926076'
    }
  },
  burgos: {
    path: '/pop-up-stores-burgos',
    routeName: 'LandingPageBurgos',
    bounds: '42.41157174,-3.6375965,42.2779166,-3.7421135',
    origin: '42.3439,-3.6969',
    address: 'Burgos, Spain',
    image: burgosImage, // Corrected filename case
    searchParams: {
      address: 'Burgos%2C%20provincia%20de%20Burgos%2C%20España',
      bounds: '42.41157174%2C-3.6375965%2C42.2779166%2C-3.7421135'
    }
  }
};